import React from 'react';
import { ProgressBar } from '@platform/base';
import { theme, getTheme } from '@platform/api';
import FormCardTooltip from './FormCardTooltip';
class Pie extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            width: 40,
            height: 40,
        };
    }

    componentDidMount() {
        let mockData = [
            { name: 'data1', value: 0.1, color: 'red' },
            { name: 'data2', value: 0.2, color: 'blue' },
            { name: 'data3', value: 0.4, color: 'green' },
            { name: 'data4', value: 0.3, color: 'orange' },
        ];
        let data = this.props.data || mockData;
        let canvas = this.box;
        let ctx = canvas.getContext('2d');
        let canvasWidth = Math.ceil(canvas.getBoundingClientRect().width) || 60;
        this.setState({
            width: canvasWidth,
            height: canvasWidth,
        }, () => {
            console.log("我要开始画饼啦，宽度为", canvasWidth);

            let x = canvasWidth / 2,
                y = canvasWidth / 2,
                radius = canvasWidth / 4,
                tempAngle = 0;
            data.forEach(item => {
                //绘制扇形
                ctx.beginPath();
                ctx.moveTo(x, y);
                ctx.fillStyle = item.color;
                let angle = 360 * item.value;
                let endAngle = tempAngle + angle;
                ctx.arc(x, y, radius, tempAngle * Math.PI / 180, endAngle * Math.PI / 180, false);
                ctx.closePath();
                ctx.fill();

                //绘制扇形上边的文字
                // let textAngle = tempAngle + angle/2;
                // let textY = radius * Math.sin(textAngle * Math.PI / 180 ) + y;
                // let textX = radius * Math.cos(textAngle * Math.PI / 180 ) + x;
                // ctx.fontSize = '12px';
                // ctx.textAlign = 'left';
                // if(textAngle > 90 && textAngle < 270){
                //     ctx.textAlign = 'right';
                //     ctx.fillText(item.name, textX, textY);
                // }else{
                //     ctx.fillText(item.name, textX, textY);
                // }
                tempAngle += angle;
            });
        });

        // canvas.addEventListener('mousemove', (event) => {
        //     const rect = canvas.getBoundingClientRect();
        //     const x = event.clientX - rect.left;
        //     const y = event.clientY - rect.top;
        //     const point = {
        //         x,
        //         y,
        //     };
        //     console.log(point); // 打印点击位置坐标
        // });
    }

    render() {
        let { width, height } = this.state;
        return (
            <canvas
                ref={box => {
                    this.box = box;
                }}
                width={width}
                height={height}
            >
            </canvas>
        );
    }
}

class Line extends React.Component {
    constructor(props) {
        super(props);
        this.state = { showTip: false };
    }

    render() {
        return this.renderLine();
    }

    getPercentValue = data => {
        let maxValue = 0;
        data.forEach(item => {
            if (item.value > maxValue) {
                maxValue = item.value;
            }
        });
        let maxCount = maxValue / 0.8;
        data.forEach(item => item.percent = item.value * 100 / maxCount);
        return data;
    }

    renderLine = () => {
        let { title } = this.props;
        let mockData = [
            { name: 'data1', value: 400 },
            { name: 'data2', value: 600 },
            { name: 'data3', value: 500 },
        ];

        let data = this.getPercentValue(this.props.data || mockData);
        let overlay = <div className='form-card-tooltip-content'>{title}</div>;
        let { showTip } = this.state;
        return (
            <div className='form-card-line-chart'>
                <div
                    className='form-card-line-chart-title'
                    onMouseEnter={() => {
                        this.setState({ showTip: true });
                    }}
                    onMouseLeave={() => {
                        this.setState({ showTip: false });
                    }}
                >
                    <FormCardTooltip overlay={overlay} visible={showTip}>
                        <div className='form-card-tooltip-content'>{title}</div>
                    </FormCardTooltip>
                </div>
                <div className='form-card-line-chart-data'>
                    {
                        data.map(item => {

                            return <div className='form-card-line-chart-content' key={item.name}>
                                <div className='form-card-line-chart-name'>
                                    {item.name}
                                </div>
                                <div className='form-card-line-chart-progress'>
                                    <ProgressBar percent={item.percent} showInfo={false} />
                                </div>
                            </div>;

                        })
                    }
                </div>
            </div>
        );
    }
}

class Column extends React.Component {
    constructor(props) {
        super(props);
        this.state = { showTip: false };
    }

    render() {
        return this.renderLine();
    }

    getPercentValue = data => {
        let maxValue = 0;
        data.forEach(item => {
            if (item.value > maxValue) {
                maxValue = item.value;
            }
        });
        let maxCount = maxValue / 0.8;
        data.forEach(item => item.percent = item.value * 100 / maxCount);
        return data;
    }

    renderLine = () => {
        let { title, leftWidth } = this.props;
        let mockData = [
            { name: 'data1', value: 400 },
            { name: 'data2', value: 600 },
            { name: 'data3', value: 500 },
        ];

        let data = this.getPercentValue(this.props.data || mockData);
        let overlay = <div className='form-card-tooltip-content'>{title}</div>;
        let { showTip } = this.state;
        return (
            <div className='form-card-column-chart' style={{ width: leftWidth, flexGrow: 1, flexShrink: 0 }}>
                <div
                    className='form-card-line-chart-title'
                    onMouseEnter={() => {
                        this.setState({ showTip: true });
                    }}
                    onMouseLeave={() => {
                        this.setState({ showTip: false });
                    }}
                >
                    <FormCardTooltip overlay={overlay} visible={showTip}>
                        <div className='form-card-tooltip-content'>{title}</div>
                    </FormCardTooltip>
                </div>
                <div className='form-card-column-chart-data'>
                    {
                        data.map(item => {

                            return <div className='form-card-column-chart-content' key={item.name}>
                                <div className='form-card-column-chart-progress'>
                                    {/* <ProgressBar percent={item.percent} showInfo={false} /> */}
                                    <div className="form-card-progress-outer">
                                        <div className="form-card-progress-inner">
                                            <div className="form-card-progress-bg" style={{ height: `${(100 - item.percent)}%` }}>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='form-card-column-chart-name'>
                                    {item.name}
                                </div>
                            </div>;

                        })
                    }
                </div>
            </div>
        );
    }
}

export default class FormChart extends React.Component {
    constructor(props) {
        super(props);
        this.theme = theme;
        // strokeColor	进度条的色彩	string
        // trailColor	未完成的分段的颜色	string
        this.state = { trailColor: '#4e97ff' };
    }

    render() {
        return this.renderChart();
    }

    componentDidMount() {
        let theme = getTheme(false);
        this.setState({ theme }, ()=>{
            this.handleThemeChange();
        });
        this.theme.addListener('themeChange', this.handleThemeChange);
    }

    componentWillUnmount() {
        this.theme.removeListener('themeChange');
    }

    handleThemeChange = theme => {
        let { chartType, value = 12 } = this.props;
        if (chartType === 'ring') {
            let trailColor = value == 0 ? (theme === 'black' ? '#464951' : '#f3f3f3') : '#f3f3f3';
            this.setState({ trailColor: trailColor });
        }
    }

    renderChart = () => {
        let { chartType, value = 12 } = this.props;
        let chartDom = '';
        // 环形图 饼图 条形图 柱状图
        switch (chartType) {
            case 'ring':
                let { trailColor } = this.state;
                chartDom = <ProgressBar type="circle" strokeColor={'#55a3fa'} strokeWidth={8} trailColor={trailColor} progressStatus="normal" format={() => value} percent={value > 100 ? 100 : value} width="100%" />;
                break;
            case 'pie':
                chartDom = <Pie {...this.props} />;
                break;
            case 'bar1':
                chartDom = <Line {...this.props} />;
                break;
            case 'bar2':
                chartDom = <Column {...this.props} />;
                break;
            default:
                break;
        }
        return chartDom;
    }
}